import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from './contexts/DataContext';
import { AuthProvider } from './contexts/AuthContext';
import MapView from './pages/MapView';
import ProtectedRoute from './components/ProtectedRoute';
import DeviceManagement from './pages/DeviceManagement';
import DataPane from './pages/DataPane';
import Config from './pages/Config';
import Header from './components/layout/Header';
import Sidebar from './components/layout/Sidebar';
import Footer from './components/layout/Footer';
import Auth from './pages/Auth';
import { useAuth } from './hooks/useAuth';

const AppContent = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { user } = useAuth();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <div className="h-screen flex flex-col">
      <Header toggleSidebar={toggleSidebar} />
      <div className="flex flex-grow overflow-hidden">
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div
          className={`flex-grow flex flex-col transition-all duration-200 ${
            isSidebarOpen ? 'ml-[200px]' : 'ml-[80px]'
          }`}
        >
          <main className="flex-grow p-2 overflow-auto">
            <Routes>
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<MapView />} />
                <Route path="/device" element={<DeviceManagement />} />
                <Route path="/data" element={<DataPane />} />
                <Route path="/Config" element={<Config />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};
const App = () => {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <Routes>
            <Route path="/auth/*" element={<Auth />} />
            <Route path="/*" element={<AppContent />} />
          </Routes>
        </Router>
      </DataProvider>
    </AuthProvider>
  );
};

export default App;
